import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    dev: false,
    number: 1,
    formstatus: false,
    config: {},
    forms: {},
    preview: false,
    sets: [],
    checkSet: [],
    simulationInfo: [],
    space: [],
    slititems: [],
    railitems: [],
    partsitems: [],
    spanitems: [],
    category: {},
    railsspan: {},
    loginUser: {},
    infoitem: {},
    clothes: false,
    drag: false,
    view: 1,
    color: 0,
    checkColor: -1,
    arraybk: [],
    idx: 0,
    isWarning: {
      message: '',
      position: ''
    }
  },
  getters: {
    dev: function (state) {
      return state.dev;
    },
    number: function (state) {
      return state.number;
    },
    formstatus: function (state) {
      return state.formstatus;
    },
    forms: function (state) {
      return state.forms;
    },
    config: function (state) {
      return state.config;
    },
    preview: function (state) {
      return state.preview;
    },
    sets: function (state) {
      return state.sets;
    },
    space: function (state) {
      return state.space;
    },
    slititems: function (state) {
      return state.slititems;
    },
    railitems: function (state) {
      return state.railitems;
    },
    loginUser: function (state) {
      return state.loginUser;
    },
    partsitems: function (state) {
      return state.partsitems;
    },
    infoitem: function (state) {
      return state.infoitem;
    },
    spanitems: function (state) {
      return state.spanitems;
    },
    drag: function (state) {
      return state.drag;
    },
    clothes: function (state) {
      return state.clothes;
    },
    category: function (state) {
      return state.category;
    },
    railsspan: function (state) {
      return state.railsspan;
    },
    view: function (state) {
      return state.view;
    },
    color: function (state) {
      return state.color;
    },
    simulationInfo: function (state) {
      return state.simulationInfo;
    },
    checkColor: function (state) {
      return state.checkColor;
    },
    isWarning: function (state) {
      return state.isWarning;
    },
    arraybk: function (state) {
      return state.arraybk;
    }
  },
  mutations: {
    setDev: function (state, val) {
      state.dev = val;
    },
    setId: function (state, val) {
      state.number = Number(val);
    },
    setFormstatus: function (state, val) {
      state.formstatus = Boolean(val);
    },
    setForms: function (state, val) {
      state.forms = val;
    },
    setConfig: function (state, val) {
      state.config = val;
    },
    setPreview: function (state, val) {
      state.preview = Boolean(val);
    },
    setSets: function (state, val) {
      state.sets = val;
    },
    setSlititems: function (state, val) {
      state.slititems = val;
    },
    setRailitems: function (state, val) {
      state.railitems = val;
    },
    setPartsitems: function (state, val) {
      state.partsitems = val;
    },
    setLoginUser: function (state, val) {
      state.loginUser = val;
    },
    setInfoitem: function (state, val) {
      state.infoitem = val;
    },
    setSpanitems: function (state, val) {
      state.spanitems = val;
    },
    setSpace: function (state, val) {
      state.space = val;
    },
    setDrag: function (state, val) {
      state.drag = val;
    },
    setClothes: function (state, val) {
      state.clothes = val;
    },
    setCategory: function (state, val) {
      state.category = val;
    },
    setRailsspan: function (state, val) {
      state.railsspan = val;
    },
    setView: function (state, val) {
      state.view = val;
    },
    setColor: function (state, val) {
      state.color = val;
    },
    setSimulationInfo: function (state, val) {
      state.simulationInfo = val;
    },
    setcheckColor: function (state, val) {
      state.checkColor = val;
    },
    setMessageWarning: function (state, val) {
      state.isWarning = val;
    },
    setArraybk: function (state, val) {
      state.arraybk = val;
    },
    setIdx: function (state, val) {
      state.idx = val;
    },
    setCheckSet: function (state, val) {
      state.checkSet = val;
    }
  },
  actions: {
  }

});

export default store;



// WEBPACK FOOTER //
// ./src/stores/index.js